import { AEntity } from "./a-entity";

export class Language extends AEntity {
  code: string = '';
  designation: string = '';
  shortCode: string = '';
}
